import { Injectable } from '@angular/core';
import { iBisEditService, iBisLanguageService, iBisServerConfig } from '@dohu/ibis-common';
import { iBisEntityService } from '@dohu/ibis-entity';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService extends iBisEditService {

  constructor(lg: iBisLanguageService, public entity: iBisEntityService, public config: iBisServerConfig ) {
    super(lg);
    this.title = this.L('NOTIFICATIONS');
  }

  createDefault() {
    return {};
  }
  getById(id: string, serverUrl?: string | undefined): Promise<any> {
    throw new Error('Method not implemented.');
  }
  onRemove(id: string): Promise<void> {
    throw new Error('Method not implemented.');
  }
  onSaveEv(serverUrl?: string | undefined): Promise<any> {
    throw new Error('Method not implemented.');
  }
  reset(): void {
    throw new Error('Method not implemented.');
  }

  seeAllNotifications(notifcationIds:string[], userId:string) {
    return this.entity.execute("NotifySeen", { userId : userId, notifyIds : notifcationIds }, this.config.saasServer);
  }

  override popupInit(event: any): void {
    super.popupInit(event);
    event.component.beginUpdate();
    event.component.option('toolbarItems', []);
    event.component.endUpdate();
  }

  
}
